import { TransformInt } from '../../../decorators/transform-int.decorator';

export class RecordSummaryFilters {
  @TransformInt()
  trendPoints?: number;

  @TransformInt()
  trendDays?: number;
}
